module.exports = __webpack_public_path__ + "img/milestone__05.6b404d8d.jpg";